import { createFileRoute } from "@tanstack/react-router";
import { StateLocationsHub, type StateCity } from "@/components/site/StateLocationsHub";
import edina__asset from "@/assets/restore/locations/edina.jpg.asset.json";

const cities: StateCity[] = [
  {
    name: "Edina",
    address: "5201 Eden Ave, Suite 300",
    img: edina__asset.url,
    mapUrl:
      "https://www.google.com/maps/search/?api=1&query=5201+Eden+Ave+Edina+MN",
    to: "/locations/minnesota/edina/",
  },
];

export const Route = createFileRoute("/locations/minnesota/")({
  head: () => ({
    meta: [
      { title: "Minnesota Hair Transplants | RESTORE® Hair" },
      {
        name: "description",
        content:
          "RESTORE® Hair in Minnesota. Book a free personal hair loss consultation at our Edina location and learn about our FUE hair transplant procedure.",
      },
      { property: "og:title", content: "Minnesota Hair Transplants | RESTORE® Hair" },
      {
        property: "og:description",
        content:
          "See RESTORE® Hair in Edina, Minnesota and book a free consultation to learn about the FUE procedure.",
      },
      { property: "og:url", content: "https://restorehair.com/locations/minnesota/" },
    ],
    links: [{ rel: "canonical", href: "https://restorehair.com/locations/minnesota/" }],
  }),
  component: () => <StateLocationsHub stateName="Minnesota" cities={cities} />,
});